import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

type Mode = 'push' | 'vpn';

@Component({
  selector: 'zui-zcli-examples',
  templateUrl: './zcli-examples.component.html',
  styleUrl: './zcli-examples.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZcliExamplesComponent {

  // # Inputs

  mode = input<Mode>('push');
  projectId = input<string>()
  projectName = input<string>()
  serviceId = input<string>();
  serviceName = input<string>();
  region = input<string>();

  // # Angular

  zcliServiceCommand = computed(() => `zcli push${this.serviceId() ? ` --serviceId=${this.serviceId()}` : this.serviceName() ? ` ${this.serviceName()}` : '' }`);
  zcliRegion = computed(() => (this.region() && this.region() !== 'zerops' ? (' --region=' + this.region()) : ''))

  // # Data
  // -- sync
  accessTokenSettingsUrl = `${window.location.protocol}//${location.host}/settings/token-management`;

}
